// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__BU16Y","large":"styles_large__1V1pG"};